import { useLocation } from "react-router-dom";
import { useSection } from "@/hooks/useCMS";

// Admin draft preview: logged-in admin visiting any public page with ?preview=1
// sees disabled sections (dashed outline + ribbon) instead of them being hidden.
export function usePreview() {
  const loc = useLocation();
  const hasToken = typeof window !== "undefined" && !!localStorage.getItem("suym_token");
  return hasToken && new URLSearchParams(loc.search).get("preview") === "1";
}

// Build inline background style from editor-chosen colour / image + overlay.
function bgStyle(s) {
  const style = {};
  const overlay = Math.min(100, Math.max(0, Number(s?.bg_overlay) || 0)) / 100;
  if (s?.bg_image) {
    const grad = overlay ? `linear-gradient(rgba(0,0,0,${overlay}),rgba(0,0,0,${overlay})),` : "";
    style.backgroundImage = `${grad}url(${s.bg_image})`;
    style.backgroundSize = "cover";
    style.backgroundPosition = s.bg_image_pos || "center";
  } else if (s?.bg_color) {
    style.backgroundColor = s.bg_color;
  }
  return style;
}

export function CmsSection({ sk, children }) {
  const s = useSection(sk);
  const preview = usePreview();
  const disabled = s && s.enabled === false;
  if (disabled && !preview) return null;
  const style = { order: s?.order ?? 0, ...bgStyle(s) };
  const light = s?.text_light === "yes";
  return (
    <div style={style} className={`${disabled ? "relative" : ""} ${light ? "text-white" : ""}`} data-testid={`section-wrap-${sk}`}>
      {disabled && (
        <div className="sticky top-0 z-20 bg-[#DB1A5C] text-white text-center text-xs font-black uppercase tracking-wider py-1.5" data-testid={`draft-ribbon-${sk}`}>
          Draft — hidden from the public
        </div>
      )}
      <div className={disabled ? "opacity-70 outline-dashed outline-2 outline-[#DB1A5C] outline-offset-[-4px]" : undefined}>{children}</div>
    </div>
  );
}
